import React from 'react'
import { AlertCircle } from 'lucide-react'
import { tx } from '../../lib/i18n'

interface ErrorStateProps {
  message?: string
  onRetry?: () => void
}

const ErrorState: React.FC<ErrorStateProps> = ({
  message = 'Something went wrong. Please try again.',
  onRetry,
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      <div className="p-4 bg-red-50 rounded-2xl mb-4">
        <AlertCircle className="h-8 w-8 text-red-400" />
      </div>
      <h3 className="text-sm font-semibold text-gray-700">{tx('Error')}</h3>
      <p className="mt-1 text-sm text-gray-400 max-w-sm">{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="mt-4 px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 transition-colors"
        >
          {tx('Try Again')}
        </button>
      )}
    </div>
  )
}

export default ErrorState
